import { render, staticRenderFns } from "./SwitchComponent.vue?vue&type=template&id=34d565ae&scoped=true&"
import script from "./SwitchComponent.vue?vue&type=script&lang=ts&"
export * from "./SwitchComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchComponent.vue?vue&type=style&index=0&id=34d565ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d565ae",
  null
  
)

export default component.exports